import { dispose } from '@react-three/fiber'
import { useEffect, useMemo } from 'react'
import { memoizedColumnsMeshes } from '~/components/DrawingCanvas/lib/collisionMeshes'
import { useAppSelector } from '~/store/hooks'

export const useColumnsMeshes = () => {
  const roofSections = useAppSelector(state => state.objects.present.roofSections)
  const meshes = memoizedColumnsMeshes(roofSections)
  const cloned = useMemo(() => Array.from(meshes).map(([id, mesh]) => [id, mesh?.clone()] as const), [meshes])

  useEffect(() => () => cloned.forEach(([, mesh]) => mesh && dispose(mesh)), [cloned])

  return cloned
}
